export default {
  dev: 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBANVppS3cUSf7QY5oTCz349QcFwUPbnHgUsq3h1IiJa0ZBCy4iixzzkyvu+FcFLh2+f39cCbZYP1UEMtoeMXvyGUCAwEAAQ==',
  test: 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBANVppS3cUSf7QY5oTCz349QcFwUPbnHgUsq3h1IiJa0ZBCy4iixzzkyvu+FcFLh2+f39cCbZYP1UEMtoeMXvyGUCAwEAAQ==',
  prod: 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBANVppS3cUSf7QY5oTCz349QcFwUPbnHgUsq3h1IiJa0ZBCy4iixzzkyvu+FcFLh2+f39cCbZYP1UEMtoeMXvyGUCAwEAAQ=='
};
